import styled from 'styled-components'

export const PagesListContainer = styled.div`
  display: inline-flex;
  flex-direction: column;
  width: 100%;
  padding: 0 30px 10px 30px;
  a{
    display: inline;
    text-decoration: none;
    color: #000
  }
`
